/**
 * created by li si yi
 */
import React, {Component} from "react";

import "./StatciMyDesktop.css";
import {HEADER_HEIGHT} from "../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import OrderDay from "./components/orderDay/OrderDay";
import PMSStoryStatisticsSMGComponents from "./components/pmsStoryStatisticsSMG/PMSStoryStatisticsSMGComponents";
import NewContribution from "./components/newContribution/NewContribution";
import WorkDesktopUntreated from "./components/workDesktopUntreated/WorkDesktopUntreated";

export default class StaticMyDesk extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let height =  document.body.clientHeight - HEADER_HEIGHT -10 ;
        return (

                <div style={{height:height,marginTop:'15px',}}>
                    <Scrollbars
                        autoHide
                        autoHeightMax={height}

                    >
                    <div className={"myDeskPadding"} style={{position: "relative"}}>
                        <div style={{display: "flex",justifyContent: 'center'}}>
                            <div className={"myDeskLeft"} style={{width: '67%',height:'100%'}}>
                                <WorkDesktopUntreated/>
                                <PMSStoryStatisticsSMGComponents/>
                            </div>
                            <div className={"myDeskRight"} style={{width: '33%'}}>

                                <OrderDay/>
                                <NewContribution/>
                            </div>
                        </div>
                    </div>
                    </Scrollbars>
                </div>


        );
    }
}

